import React, { useMemo } from 'react';
import NavigationStepper, {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import NCZISetupModalContent from '../NCZISetup/NCZISetupModalContent';
import NCZIWizardRequirements from './NCZIWizardSteps/NCZIWizardRequirements';
import NCIWizardSetupInstructions from './NCZIWizardSteps/NCIWizardSetupInstructions';
import NCZIWizardCardConnectionCheck from './NCZIWizardSteps/NCZIWizardCardConnectionCheck';

interface Props {
	onFinish: () => void;
	showFinishButton?: boolean
}

const NCZIWizard: React.FC<Props> = ({ onFinish, showFinishButton = false }) => {
	const steps: NavigationStepperItemType[] = useMemo(() => {
		return [
			{
				name: 'requirements',
				key: 'requirements',
				component: (params: NavigationStepperComponentParams) => (
					<NCZIWizardRequirements
						onContinue={() => params.setActiveStepPath('setupInstructions')}
					/>
				),
			},
			{
				name: 'setupInstructions',
				key: 'setupInstructions',
				component: (params: NavigationStepperComponentParams) => (
					<NCIWizardSetupInstructions
						onContinue={() => params.setActiveStepPath('cardConnectionCheck')}
					/>
				),
			},
			{
				name: 'cardConnectionCheck',
				key: 'cardConnectionCheck',
				component: (params: NavigationStepperComponentParams) => (
					<NCZIWizardCardConnectionCheck
						onContinue={() => params.setActiveStepPath('ncziSetup')}
					/>
				),
			},
			{
				name: 'ncziSetup',
				key: 'ncziSetup',
				component: (params: NavigationStepperComponentParams) => (
					<NCZISetupModalContent onClose={onFinish} showFinishButton={showFinishButton} />
				),
			},
		];
	}, []);

	return (
		<NavigationStepper
			steps={steps}
			initialStepPath='requirements'
			showStepNavigation={false}
		/>
	);
};

export default NCZIWizard;
